import { AccessToken, Role } from 'hooks/auth/Token';
import React from 'react';
import { useAuth } from './AuthContext';

interface RoleRendererProps {
    allowedRoles: Role[];
    children?: React.ReactNode;
    elementRenderer?: (token: AccessToken) => React.ReactNode;
}

const RoleRenderer: React.FC<RoleRendererProps> = ({allowedRoles, children, elementRenderer}) => {
    const { token } = useAuth();

    if (token === null || !token.activeRole || !allowedRoles.some(role => token.activeRole.roleId === role)) {
        return null;
    }

    return <>{elementRenderer ? elementRenderer(token) : children}</>;
};

export default RoleRenderer;